import { style } from "@vanilla-extract/css";
import { primitiveTokens } from "../theme/ThemeTokens.css";
import { hslaWithAlpha } from "../utils/hslaWithAlpha";

export const loadingOverlay = style({
  position: "absolute",
  inset: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: hslaWithAlpha(primitiveTokens.colors.white[1000], 0.15),
  zIndex: 1,
  pointerEvents: "all"
});
